import { styled } from "@mui/material";

export const CheckBoxContainer = styled("div")(() => ({
  width: "300px",
}));
